import React from 'react';

import { NamedLink } from '../index';

const WatchlistAlertContent = (props) => {
  const {
    listingIds,
    listingId,
    showView,
  } = props;

  const link = <NamedLink name="FavoritesPage">View</NamedLink>;
  return listingIds.includes(listingId)
    ? (<div>Listing saved to your watchlist. {showView ? link : null}</div>)
    : (<div>Listing removed from your watchlist. {showView ? link : null}</div>)
  ;
};

WatchlistAlertContent.defaultProps = {
  showView: true,
};

export default WatchlistAlertContent;
